<template>
	<b-modal 	:id="id"
				size="lg"
				centered
				hide-footer
				hide-header>
		<b-row class="py-2 py-lg-4">
			<b-col cols="12" class="text-center">
				<b-img :src="require('../assets/img/group'+openId+'.png')" class="img-playbook"/>
			</b-col>
			<b-col cols="12" class="text-center">
				<p class="m-0 pt-3 medium">
					{{ modalData[openId].title }}
				</p>
			</b-col>
		</b-row>
		<b-row class="align-items-center">
			<b-col cols="1" lg="2" class="px-0 text-center">
				<a :href="'#'" class="d-block w-100 h-100" @click.prevent="openId === 0 ? openId = 6 : openId--">
					<!-- <b-img src="../assets/icons/pb-arrow-left.svg" class="h-30"/> -->
				</a>
			</b-col>
			<b-col cols="10" lg="8" class="text-center font-weight-light content-text px-0">
				<p class="m-0 px-2">
					{{ modalData[openId].content }}
				</p>
			</b-col>
			<b-col cols="1" lg="2" class="px-0 text-center">
				<a :href="'#'" @click.prevent="openId === 6 ? openId = 0 : openId++">
					<!-- <b-img src="../assets/icons/pb-arrow-right.svg" class="h-30"/> -->
				</a>
			</b-col>
		</b-row>
		<b-row>
			<b-col cols="12" class="text-center py-2">
				<a href="#" @click.prevent="$bvModal.hide(id)" class="btn btn-light">
					Close
				</a>
			</b-col>
		</b-row>
	</b-modal>
</template>
<script>
	export default {
		props: {
			id: {
				type: String,
				default: 'myModal'
			},
			section: {
				type: Number,
				default: 1
			}
		},
		data() {
			return {
				openId: 0,
				modalData: [
					{
						title: 'Thematic and sector-based approach',
						content: 'EQT applies a thematic mindset in deal sourcing that aims to identify underlying macro trends and investment opportunities across sectors and strategies. With this approach, EQT targets highquality companies with sustainable growth potential in attractive industries with secular growth drivers and strong downside protection. EQT combines its thematic approach with deep sector expertise. Within the selected sectors, EQT generally targets companies with leading market positions and good prospects for future growth and operational improvements. Potential investment themes are regularly reviewed and examined.'
					},
					{
						title: 'Locals-with-locals',
						content: 'EQT believes that local knowledge, local business relationships and local presence are all critical to securing a competitive edge in private markets, including access to local deal flow, being a preferred partner for management teams and ultimately winning deals.'
					},
					{
						title: 'Governance model',
						content: 'EQT’s governance model is designed to enable accountability, promote fast decision making and empower EQT funds’ portfolio companies’ CEOs while allowing for informal free thinking and limited internal politics. The TROIKA governance model consists of the portfolio company’s Chairperson, a Partner at EQT and the portfolio company’s CEO.'
					},
					{
						title: 'EQT Network',
						content: 'EQT has a global network of advisors with a variety of backgrounds, including entrepreneurs and current or former executives of major international corporations. The advisors are an integral part of the EQT Playbook, adding operational, strategic expertise and experience to the EQT funds’ portfolio companies.'
					},
					{
						title: 'House of Value Creation',
						content: 'EQT AB Group applies an integrated framework of tools and best practices to support value creation and performance in EQT funds’ portfolio companies. The framework is divided into numerous value creation levers and tools, including revenue enhancements, change management, pricing, cost improvements, strategic realignment and add-on acquisitions.'
					},
					{
						title: 'Sustainability',
						content: 'EQT strives to scale solutions with a positive societal impact and instill sustainable practices in all companies the EQT funds invest in, from start-ups to already mature companies. EQT applies responsible investment and ownership prin-ciples and practices as an integrated part throughout the investment cycle.'
					},
					{
						title: 'Digitalization',
						content: 'EQT aims to drive digital transformation for all companies in which EQT funds invest. Its digital efforts center around a firmly held belief that digitally leading firms are future winners, and EQT has therefore made significant investments in its digital capabilities.'
					}
				]
			}
		},
		watch: {
			section() {
				this.openId = this.section
			}
		}
	}
</script>
